import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

// Create rtl cache
const cacheRtl = createCache({
    key: 'muirtl',
    // @ts-ignore
    stylisPlugins: [prefixer, rtlPlugin],
});

export default function RTL(props: any) {
    document.dir = props.direction
    if (props.direction === 'rtl') {
        return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>;
    } else {
        return props.children;
    }
}